import { getAccessTokenInfo } from "@/authentication/authentication";
import { CONTENT_TYPES, createUrlQueryParams, HTTP_METHODS, makeRequest } from "@/utils/http/httpClient";
import { END_POINTS } from "@/config/endPoints";

export async function getUserProfile() {
  const tokenInfo: any = await getAccessTokenInfo();
  const token = `${tokenInfo.tokenType} ${tokenInfo.accessToken}`;
  const headers = {
    Authorization: token,
    "Content-Type": CONTENT_TYPES.JSON
  };

  const userId = tokenInfo.uniqueId;
  const queryParams = [
    "id",
    "employeeid",
    "mail",
    "displayname",
    "jobtitle",
    "companyname",
    "department",
    "officelocation",
    "country"
  ];

  const url = createUrlQueryParams(`${END_POINTS.GRAPH_USERS}/${userId}`, { $select: queryParams });

  const userProfileResponse = await makeRequest({
    endPoint: url,
    method: HTTP_METHODS.GET,
    headers
  });

  if (!userProfileResponse.userRoles) {
    userProfileResponse["roles"] = userProfileResponse.userRoles
      ? userProfileResponse.userRoles
      : tokenInfo.account?.idTokenClaims?.roles;
  }

  const userRoles = userProfileResponse.userRoles
    ? userProfileResponse.userRoles
    : tokenInfo.account?.idTokenClaims?.roles;

  userProfileResponse["userGroupMemberships"] = tokenInfo.account?.idTokenClaims?.groups;

  return {
    ...userProfileResponse,
    roles: userRoles
  };
}
